module.exports = __webpack_public_path__ + "images/emoji/waning_crescent_moon.eaf981c84fea65861e41.png";